import { AritoFormV2 } from '@/components/custom/erp';
import { useFormDialog } from './hooks/useFormDialog';
import { FormBottomBar, FormTabs } from './FormTabs';
import type { AddFormProps } from './types';
import InfoDropdown from './InfoDropdown';
import { FormHeader } from './FormHeader';

export const AddForm = (props: AddFormProps) => {
  const dialog = useFormDialog(props);

  return (
    <div
      className='h-full flex-1 overflow-auto'
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      <AritoFormV2
        mode={dialog.formMode}
        hasAritoActionBar={true}
        initialData={dialog.initialValues}
        onSubmit={dialog.submit}
        onClose={dialog.onClose}
        schema={dialog.schema}
        title={dialog.title}
        subTitle='Giấy báo có'
        headerFields={FormHeader(dialog)}
        headerTabActions={
          dialog.formMode !== 'add' &&
          dialog.initialData?.uuid && (
            <InfoDropdown
              uuid={dialog.initialData.uuid}
              ma_ct={typeof dialog.initialData?.chung_tu === 'string' ? dialog.initialData.chung_tu : undefined}
            />
          )
        }
        tabs={FormTabs(dialog)}
        actionButtons={dialog.actionButtons}
        bottomBar={FormBottomBar(dialog)}
      />
    </div>
  );
};
